import { Suspense, useContext, useState } from "react";
import { lazyWithReload } from "../../lib/lazyWithReload";
import { Box, IconButton, Tooltip } from "@mui/material";
import { styles } from "../TracksPageComponents/styles";
import { THEME } from "../../theme";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { AuthContext, AuthContextInterface } from "../../contexts";

const SupportModal = lazyWithReload(() =>
  import("../Modal/SupportModal").then((m) => ({ default: m.SupportModal }))
);

export const DrawerSocialMediaLinks: React.FC = () => {
  const { userId } = useContext<AuthContextInterface>(AuthContext);
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);

  return (
    <>
      <Box sx={styles.socialMediaLinksContainer}>
        <a
          target="_blank"
          href="https://www.facebook.com/ommuse.music"
          rel="noreferrer"
        >
          <Tooltip title="Facebook">
            <IconButton sx={styles.iconButton}>
              <Box sx={styles.socialButtonContainer}>
                <img
                  style={{ width: "24px", height: "24px" }}
                  src="/assets/icons/TracksPageIcons/Social icon.svg"
                  alt="icon"
                />
              </Box>
            </IconButton>
          </Tooltip>
        </a>
        <a
          target="_blank"
          href="https://www.instagram.com/ommuse.music/"
          rel="noreferrer"
        >
          <Tooltip title="Instagram">
            <IconButton sx={styles.iconButton}>
              <Box sx={styles.socialButtonContainer}>
                <img
                  style={{ width: "24px", height: "24px" }}
                  src="/assets/icons/TracksPageIcons/Group.svg"
                  alt="icon"
                />
              </Box>
            </IconButton>
          </Tooltip>
        </a>
        <a target="_blank" href="https://youtube.com/@ommuse/" rel="noreferrer">
          <Tooltip title="Youtube">
            <IconButton sx={styles.iconButton}>
              <Box
                sx={{
                  ...styles.socialButtonContainer,
                  ...{ paddingTop: "4px", paddingBottom: "4px" },
                }}
              >
                <YouTubeIcon sx={{ height: "20px" }} />
              </Box>
            </IconButton>
          </Tooltip>
        </a>
        <Tooltip title="Support">
          <IconButton
            sx={styles.iconButton}
            onClick={() => setIsSupportModalOpen(true)}
            aria-label="Contact support"
          >
            <Box sx={styles.socialButtonContainer}>
              <img
                style={{
                  filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
                }}
                src="/assets/icons/TracksPageIcons/life-buoy-01.svg"
                alt="icon"
              />
            </Box>
          </IconButton>
        </Tooltip>
      </Box>
      {isSupportModalOpen && (
        <Suspense fallback={null}>
          <SupportModal
            isSupportModalOpen={isSupportModalOpen}
            setIsSupportModalOpen={setIsSupportModalOpen}
            userId={userId}
          />
        </Suspense>
      )}
    </>
  );
};
